import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DropdownComponent } from './ui-components/dropdown/dropdown.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { CheckboxComponent } from './ui-components/checkbox/checkbox.component';
import { PhoneNumberInputComponent } from './ui-components/phone-number-input/phone-number-input.component';
import { EmailInputComponent } from './ui-components/email-input/email-input.component';
import { EmailInputBuilderComponent } from './feature-components/email-input-builder/email-input-builder.component';
import { TooltipComponent } from './ui-components/tooltip/tooltip.component';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { InlineDatepickerComponent } from './ui-components/inline-datepicker/inline-datepicker.component';
import { UnderscoreToSpacePipe } from './pipes/underscore-to-space.pipe';
import { PhoneNumberPipe } from './pipes/phone-number.pipe';
import { ErrorMessageComponent } from './ui-components/error-message/error-message.component';
import { InputComponent } from './ui-components/input/input.component';
import { DomainInputComponent } from './ui-components/domain-input/domain-input.component';
import { NotificationComponent } from './ui-components/notification/notification.component';
import { CapitalizeAndSpaceCamelCasePipe } from './pipes/capitialize.pipe';
import { TwelveHourTimeComponent } from './ui-components/twelve-hour-time/twelve-hour-time.component';
import { EwebLinksComponent } from '../eweb-signup/components/eweb-links/eweb-links.component';
import { ConnLabelWithTooltipComponent } from '@share/ui-components/conn-label-with-tooltip/conn-label-with-tooltip.component';
import { EfanInputComponent } from '@share/ui-components/efan-input/efan-input.component';
import { VersionFooterComponent } from '@share/ui-components/version-footer/version-footer.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgxDatatableModule,
    NgbModule,
    NgxMaskDirective,
  ],
  declarations: [
    DropdownComponent,
    CapitalizeAndSpaceCamelCasePipe,
    CheckboxComponent,
    PhoneNumberInputComponent,
    EmailInputComponent,
    EmailInputBuilderComponent,
    TooltipComponent,
    InlineDatepickerComponent,
    UnderscoreToSpacePipe,
    PhoneNumberPipe,
    ErrorMessageComponent,
    InputComponent,
    DomainInputComponent,
    EfanInputComponent,
    NotificationComponent,
    TwelveHourTimeComponent,
    EwebLinksComponent,
    ConnLabelWithTooltipComponent,
    VersionFooterComponent,
  ],
  providers: [provideNgxMask()],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgxDatatableModule,
    NgbModule,
    DropdownComponent,
    CapitalizeAndSpaceCamelCasePipe,
    CheckboxComponent,
    TooltipComponent,
    EmailInputComponent,
    PhoneNumberInputComponent,
    InputComponent,
    DomainInputComponent,
    EfanInputComponent,
    PhoneNumberPipe,
    EmailInputBuilderComponent,
    InlineDatepickerComponent,
    UnderscoreToSpacePipe,
    ErrorMessageComponent,
    NotificationComponent,
    TwelveHourTimeComponent,
    EwebLinksComponent,
    ConnLabelWithTooltipComponent,
    VersionFooterComponent,
  ],
})
export class SharedModule {}
